import React from 'react';
import { Stack, Text } from '@starrez/starryui9';
import styled from 'styled-components';
import { Color } from '@starrez/starryui/dist/Theme';
import { EntryStatus, Highlighted, PascalCaseToTitleCase } from '@starrez/starryui';
import { ICellRenderer } from '../types';
import { useServerGridContext } from '../../ServerPagedGrid/ServerPageGridContext';

export const buildColourMarker = (status: EntryStatus): IStatusMarkerDotProps => {
    switch (status) {
        case 'Admin':
            return { colorScheme: Color.Grey.G80 };
        case 'Tentative':
            return { colorScheme: Color.Teal.T80 };
        case 'Reserved':
            return { colorScheme: Color.Purple.P80 };
        case 'Held':
            return { colorScheme: Color.Teal.T80 };
        case 'InRoom':
            return { colorScheme: Color.Blue.B60 };
        case 'History':
            return { colorScheme: Color.Grey.G40 };
        case 'Occupant':
            return { colorScheme: Color.Purple.P80 };
        case 'OccupantHistory':
            return { colorScheme: Color.Grey.G40 };
        case 'OccupantInRoom':
            return { colorScheme: Color.Blue.B60 };
        case 'Attendee':
            return { colorScheme: Color.Pink.P60 };
        case 'AttendeeArrived':
            return { colorScheme: Color.Pink.P80 };
        case 'AttendeeDeparted':
            return { colorScheme: Color.Grey.G40 };
        case 'Account':
            return { colorScheme: Color.Grey.G80 };
        case 'MasterAccount':
            return { colorScheme: Color.Grey.G80 };
        case 'Cancelled':
            return { colorScheme: Color.Red.R60 };
        case 'Erased':
            return { colorScheme: Color.Grey.G40 };
        case 'Application':
            return { colorScheme: Color.Green.G80 };
        case 'Incident':
            return { colorScheme: Color.Orange.O80 };
        case 'Contact':
            return { colorScheme: Color.Pink.P100 };
        case 'Alumni':
            return { colorScheme: Color.Purple.P100 };
    }
};

export interface IStatusMarkerDotProps {
    colorScheme: string;
}

export const StatusMarkerDot = styled.span<IStatusMarkerDotProps>`
    background-color: ${(props) => props.colorScheme};
    border-radius: 50%;
    height: 12px;
    width: 12px;
`;

export const EntryStatusColumn = (props: ICellRenderer<EntryStatus>) => {
    const { getCurrentHighlight } = useServerGridContext();
    return (
        <Stack height="100%" templateColumns="20px 1fr" inline>
            <StatusMarkerDot {...buildColourMarker(props.value)} />
            <Text variant="normal.regular" color={Color.Grey.G80}>
                <Highlighted Text={PascalCaseToTitleCase(props.value)} Highlight={getCurrentHighlight()} />
            </Text>
        </Stack>
    );
};
